module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Coming Up for Air")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Amanda Meuwissen")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It’s not easy being someone’s fairy tale.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh Hurley is making a name for himself among thieves and criminals, even if it isn’t the life he would’ve chosen. He shouldn’t have screwed over the Moretti brothers, though. It landed him in the river with weights on his feet. But somehow he’s escaped certain death. The last thing he remembers before waking on the riverbank is a beautiful face and a soft kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then, Tolomeo turns up naked at Leigh’s apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly comes from a race of killers—merfolk who drown humans for fun. But Tolly is different, and when he sees a human in trouble, he offers a kiss, granting the man the ability to breathe underwater… and himself the ability to walk on land, at least until the next full moon. The ancient laws state that if he is given a vow of love by the one he kissed, he will be able to keep his legs. If not, he will be put to death when he returns to the water.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But love is not something Leigh offers easily… and Tolly has a secret of his own.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e555470","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0002.vue
// module id = 60
// module chunks = 0